import styled from 'styled-components';

import { NotificationBanner } from 'cosmos-components';

export const StyledForm = styled.form``;

export const HeaderContainer = styled.div`
    border-bottom: 2px solid
        ${({ theme: { colors } }) => colors.secondaryOrange};
`;

export const Header = styled.h3`
    font-size: 1.4rem;
    margin: 1rem 0;
`;

export const FieldsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    margin: 2rem 0;

    label {
        display: block;
    }
`;

export const StyledNotificationBanner = styled(NotificationBanner)`
    width: 90%;
    margin-left: auto;
    margin-right: auto;
`;
